"use client";

import { Grid } from "@jesus-central-church/ui";
import {
  SbBlokData,
  StoryblokServerComponent,
  storyblokEditable,
} from "@storyblok/react/rsc";
import { SbGrid } from "@storyblok/types/287435740670216/storyblok-components";

/**
 * Grid component for Storyblok
 * NOTE: Grid should be placed inside a Section for proper spacing
 * It does not add its own vertical padding - that comes from Section
 */
export function GridComponent({
  blok,
  pageData,
}: {
  blok: SbGrid;
  pageData: { locale: string };
}) {
  return (
    <Grid
      columns={blok.columns?.length}
      {...storyblokEditable(blok as SbBlokData)}
    >
      {blok.columns?.map((nestedBlok) => (
        <div key={nestedBlok._uid} className="h-full">
          <StoryblokServerComponent blok={nestedBlok} pageData={pageData} />
        </div>
      ))}
    </Grid>
  );
}
